<input #fileInput type="file" hidden [accept]="accept" (change)="onFileChange($event)" />
